<template lang="pug">
	.creative--file-upload-request
		Popup(v-if="popupVisible", :popupVisible="popupVisible", :width="460", :autosize="true", :title="$tCaption('File upload request')")
			.content
				.flex-col.space-medium
					.flex-col
						.font-small.upper {{$tCaption('Email')}}
						DxTextBox(:value.sync="email", stylingMode="filled", valueChangeEvent="input")
				Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions')", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(:text="$tCaption('Send', '@actions')", @click="sendRequest", type="success", :disabled="!validated || !!isLoading")
		template(v-if="uploadMode")
			.flex-row.full-width.center.space
				template(v-if="!isUploaded")
					DxButton(v-if="request", :text="uploadActionText", icon="upload", @click="initUpload", :disabled="isLoading || creativeIsBusy")
				template(v-else)
					.flex-row.space.align-center.font-big
						fas(icon="check")
						.upper {{ $tCaption('File has been successfully uploaded.') }}
		Loader(v-if="isLoading || (uploadMode && creativeIsBusy) || (uploadMode && !request)", :text="$tCaption('Loading', '@actions') + '..'", :fullscreen="true")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'creative.CreativeFileUploadRequest',
		name: 'creative-file-upload-request',
		components: {
			Loader, Popup, DxTextBox, DxButton
		},
		props: ['creative', 'uploadMode', 'creativeIsBusy', 'tracker', 'createInsertion'],
		data() {
			return {
				isLoading: 0,
				popupVisible: false,
				aggTrack: null,
				email: null,
				request: null,
				isUploaded: false
			};
		},
		computed: {
			validated() {
				return !!this.email;
			},
			uploadActionText() {
				if (this.aggTrack) {
					return this.$tCaption('Upload file to "TRACK_NAME"').replace(/TRACK_NAME/g, this.aggTrack.name);
				}
				return this.$tCaption('Upload file to track');
			},
			fileUploadRequestId() {
				return this.$route.query?.uploadRequestId;
			}
		},
		watch: {
			creative() {
				if (this.uploadMode && this.creative) {
					this.loadRequest();
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.fileUploadRequest = this;

			if (this.uploadMode && this.creative) {
				this.loadRequest();
			}

			this.$eventsBus.$on('tracker-new-track', this.onTrackerNewTrack);
		},
		destroyed() {
			this.$eventsBus.$off('tracker-new-track', this.onTrackerNewTrack);
		},
		methods: {
			onTrackerNewTrack(track) {
				if (this.fileUploadRequestId && this.uploadMode) {
					this.$set(track.insertion.JsonConfig, 'fileUploadRequestId', this.fileUploadRequestId);
					track.__saveInsertion();
					this.isUploaded = true;

					this.$Data.postExternalApi('TrackFileUpload/SendUploadedMessage', {
						ObjectId: this.fileUploadRequestId,
						FileName: track.insertion?.Audio?.FileName || track.name()
					});
				}
			},
			show(aggregatedTrack) {
				this.popupVisible = false;
				this.aggTrack = aggregatedTrack;
				if (__DEBUG__)
					window.fileUploadRequest = this;
				
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
				});
			},
			async sendRequest() {
				try {
					this.isLoading++;

					let request = (await this.$Data.postExternalApi('TrackFileUpload/CreateUpdate', {
						Creative: {
							Oid: this.creative.Oid
						},
						TrackNumber: this.aggTrack.trackNumber,
						Email: this.email
					}))?.Data;

					if (request?.Oid) {
						await this.$Data.postExternalApi('TrackFileUpload/SendRequest', {
							Oid: request.Oid
						});

						this.$notifySuccess('File upload request has been successfully sent.');

						this.popupVisible = false;
					}
				} finally {
					this.isLoading--;
				}
			},
			async loadRequest() {
				let id = this.$route.query?.uploadRequestId;
				if (id) {
					this.isLoading++;
					try {
						this.request = await this.$Data.getExternalApi('TrackFileUpload/Get', `id=${id}`);
						this.aggTrack = this.creative.JsonConfig.aggregatedTracks.find(f => f.trackNumber === this.request.TrackNumber);
					} finally {
						this.isLoading--;
					}
				}
			},
			initUpload() {
				this.isUploaded = false;
				this.tracker.focusedAggregatedTrack = this.aggTrack;
				this.createInsertion('media');

				if (this.aggTrack?.__tracks?.length) {
					this.$nextTick(() => {
						this.tracker.currentTime = _.max(this.aggTrack.__tracks.map(f => f.start + f.duration));
						let existing = this.aggTrack.__tracks.find(f => f.insertion.JsonConfig.fileUploadRequestId === this.fileUploadRequestId);
						if (existing) {
							this.$emit('edit', existing);
						}
					});
				}
			}
		}
	};
</script>
<style lang='scss'>
	.creative--file-upload-request{
	}
</style>
